/**
 * AI Insights API client (P3-S5 Doc 46).
 */
import { api } from "@/api/client";

export interface SummaryOut {
  id: string;
  user_id: string;
  user_email?: string | null;
  period: string;
  period_start: string;
  period_end: string;
  summary_text: string;
  highlights: Record<string, unknown> | null;
  message_count: number;
  conversation_count: number;
  llm_provider: string | null;
  llm_model: string | null;
  tokens_used: number | null;
  generated_at: string;
}

export interface InsightsListResponse {
  items: SummaryOut[];
}

export interface GenerateNowResponse {
  ok: boolean;
  summary?: SummaryOut | null;
  error?: string | null;
}

export interface AdminTriggerResponse {
  ok: boolean;
  summary?: SummaryOut | null;
  error?: string | null;
}

export const myInsightsApi = {
  list: (limit = 8): Promise<InsightsListResponse> =>
    api.get<InsightsListResponse>("/api/v1/me/insights", { query: { limit } }),
  latest: (): Promise<SummaryOut | null> =>
    api.get<SummaryOut | null>("/api/v1/me/insights/latest"),
  generateNow: (target: "current_week" | "previous_week" = "current_week") =>
    api.post<GenerateNowResponse>("/api/v1/me/insights/generate-now", null, {
      query: { target },
    }),
};

export const adminInsightsApi = {
  list: (limit = 50, offset = 0): Promise<InsightsListResponse> =>
    api.get<InsightsListResponse>("/api/v1/admin/insights", {
      query: { limit, offset },
    }),
  trigger: (
    user_id: string,
    target: "previous_week" | "current_week" = "previous_week",
  ): Promise<AdminTriggerResponse> =>
    api.post<AdminTriggerResponse>("/api/v1/admin/insights/trigger", {
      user_id,
      target,
    }),
};
